import { useState, useCallback, useEffect } from 'react';
import axios from 'axios';

const defaultParams = {};

function useApiControl({ action, params = defaultParams, method = 'GET' }) {
  const API_URL = process.env.REACT_APP_API_URL;
  const connect_URL = `${API_URL}${action}`;

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // test block
  useEffect(() => {
    console.log('connect_URL has changed', connect_URL);
  }, [connect_URL]);
  
  useEffect(() => {
    console.log('params has changed', params);
  }, [params]);
  
  useEffect(() => {
    console.log('method has changed', method);
  }, [method]);
  // test block end

const executeRequest = useCallback(async (overrideParams = null) => {
  setLoading(true);

  const payload = overrideParams ? overrideParams : params;
  const axiosConfig = {
      url: connect_URL,
    };

  const authToken = localStorage.getItem('authToken');
  const headers = {};

  if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
  }

  if (payload instanceof FormData) {
      headers['Content-Type'] = 'multipart/form-data';
  }

  if (Object.keys(headers).length > 0) {
      axiosConfig.headers = headers;
  }

  if (method === 'POST') {
    axiosConfig.method = method;
    axiosConfig.data = payload;
  } else if (method === 'GET') {
    axiosConfig.method = method;
    axiosConfig.params = payload;
  } else {
    throw new Error(`Invalid method: ${method}`);
  }

  try {
    try {
      const response = await axios(axiosConfig);
      setData(response.data);
      setError(null);
      return response.data;
    } catch (error) {
      setError(error);
      throw error;
    }
  } finally {
    setLoading(false);
  }
}, [connect_URL, params, method]);
  
  return { data, error, loading, executeRequest };
}

export default useApiControl;
